const pagesOauth2En = {
  consent: {
    actions: {
      allow: 'Allow',
      deny: 'Deny',
    },
    audienceTitle: 'Services this app will access:',
    description:
      '{{ clientName }} is requesting access to your DRESS CODE account.',
    rememberAlways: 'Always allow this app',
    scopesTitle: 'This app will be able to:',
    title: 'Authorize {{ clientName }}',
  },
  errors: {
    accessDenied: 'Access was denied.',
    accountSelectionRequired: 'Please select the account to use.',
    backToHome: 'Back to home',
    code: 'Error code: {{ code }}',
    consentRequired: 'Please grant access to this app.',
    correlationId: 'Reference ID: {{ correlationId }}',
    correlationIdGuidance:
      'If you contact support, please provide the reference ID below.',
    interactionRequired: 'User interaction is required.',
    invalidClient:
      "The connected app has a configuration problem. Please contact the app's administrator.",
    invalidGrant:
      'The credentials have expired or become invalid. Please sign in again.',
    invalidRequest: 'The request is invalid.',
    invalidScope:
      "The permissions requested by the app are invalid. Contact the app's administrator.",
    loginRequired: 'Sign in is required.',
    serverError: 'An unexpected error occurred on the server.',
    showDetails: 'Show details',
    temporarilyUnavailable:
      'The authentication server is temporarily unavailable. Please try again in a few minutes.',
    title: 'Authentication error',
    unauthorizedClient:
      "This app is not authorized to perform authentication. Contact the app's administrator.",
    unknown: 'An unexpected error occurred. Please try again.',
    unsupportedResponseType:
      "The request method used by this app is not supported. Contact the app's administrator.",
  },
  login: {
    confirmIdentity: {
      continueAs: 'Continue as {{ email }}',
      description: 'You are signed in to DRESS CODE as {{ email }}.',
      title: 'Sign in to {{ clientName }}',
    },
    sharedInfoTitle: 'Information shared with {{ clientName }}',
    useAnotherAccount: 'Sign in with a different account',
    wrongAccount: {
      description:
        'This app is requesting a different account. You are currently signed in as {{ email }}.',
      descriptionNoEmail:
        'This app is requesting an account different from the one you are signed in with.',
      title: 'A different account is required',
    },
  },
  logout: {
    actions: {
      confirm: 'Sign out',
    },
    confirmMessage:
      'Are you sure you want to sign out of {{ clientName }} and DRESS CODE?',
    confirmMessageNoClient: 'Sign out of DRESS CODE?',
    title: 'Sign out',
  },
  progress: {
    pleaseWait: 'Please wait.',
    redirecting: "You'll be redirected to {{ clientName }} automatically.",
    redirectingNeutral: 'Redirecting automatically...',
    signingIn: 'Signing in...',
    signingInTo: 'Signing in to {{ clientName }}',
    signingOut: 'Signing out...',
  },
  scopes: {
    email: 'Your email address',
    offline_access: 'Keep you signed in',
    openid: 'View your account information',
    profile: 'Your name',
    unknown: '{{ scope }}',
  },
};

export default pagesOauth2En;
